/* unplugin-vue-components disabled */import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "patrol-scheme-detail"
};
var _hoisted_2 = {
  class: "list-detail"
};
var _hoisted_3 = {
  class: "list-detail-block"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title-icon"
}), /*#__PURE__*/_createElementVNode("div", null, "基本信息")], -1);
var _hoisted_5 = {
  class: "detail-item-content"
};
var _hoisted_6 = {
  class: "content-item"
};
var _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "计划名称", -1);
var _hoisted_8 = {
  class: "content-item-value"
};
var _hoisted_9 = {
  class: "list-detail-block list-detail-block_2"
};
var _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title-icon"
}), /*#__PURE__*/_createElementVNode("div", null, "设备信息")], -1);
var _hoisted_11 = {
  class: "content-item-title"
};
var _hoisted_12 = {
  class: "content-item"
};
var _hoisted_13 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label content-item-label_2"
}, "设备类型:", -1);
var _hoisted_14 = {
  class: "content-item-value content-item-value_2"
};
var _hoisted_15 = {
  class: "content-item"
};
var _hoisted_16 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label content-item-label_2"
}, "设备名称", -1);
var _hoisted_17 = {
  class: "content-item-value content-item-value_2"
};
var _hoisted_18 = {
  class: "content-item"
};
var _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label content-item-label_2"
}, " 设备位置： ", -1);
var _hoisted_20 = {
  class: "content-item-value content-item-value_2"
};
var _hoisted_21 = {
  class: "content-item"
};
var _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label content-item-label_2"
}, " 设备编号： ", -1);
var _hoisted_23 = {
  class: "content-item-value content-item-value_2"
};
var _hoisted_24 = {
  class: "list-detail-block list-detail-block_3"
};
var _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "detail-item-title-icon"
}), /*#__PURE__*/_createElementVNode("div", null, "任务规则")], -1);
var _hoisted_26 = {
  class: "content-item"
};
var _hoisted_27 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "任务类型", -1);
var _hoisted_28 = {
  class: "content-item-value"
};
var _hoisted_29 = {
  class: "content-item"
};
var _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "开始时间", -1);
var _hoisted_31 = {
  class: "content-item-value"
};
var _hoisted_32 = {
  class: "content-item"
};
var _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "结束时间", -1);
var _hoisted_34 = {
  class: "content-item-value"
};
var _hoisted_35 = {
  class: "content-item"
};
var _hoisted_36 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "计划巡检/保养时间", -1);
var _hoisted_37 = {
  class: "content-item-value"
};
var _hoisted_38 = {
  class: "content-item"
};
var _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "审核人", -1);
var _hoisted_40 = {
  class: "content-item-value"
};
var _hoisted_41 = {
  class: "content-item_2"
};
var _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label"
}, "任务项", -1);
var _hoisted_43 = {
  class: "content-item-value_3-content"
};
var _hoisted_44 = {
  class: "content-item inspector"
};
var _hoisted_45 = /*#__PURE__*/_createElementVNode("div", {
  class: "content-item-label content-item-label_2"
}, " 巡检/保养人： ", -1);
var _hoisted_46 = {
  class: "content-item-value content-item-value_2"
};
import { getTaskDetail } from '@/service/patrolScheme/index';
import { getDeviceType } from '@/service/deviceInfo/index';
import './detail.less';
import './common.less';
export default /*#__PURE__*/_defineComponent({
  __name: 'Detail',
  setup: function setup(__props) {
    var route = useRoute();
    var _route$query = route.query,
      id = _route$query.id,
      ruleId = _route$query.ruleId;
    var detail = ref({});
    var deviceColumns = ref([]);
    // 获取设备类型
    var getDeviceTypeList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, list;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getDeviceType('device_type');
            case 2:
              data = _context.sent;
              list = data.list;
              deviceColumns.value = list;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getDeviceTypeList() {
        return _ref.apply(this, arguments);
      };
    }();
    // const getDeviceTypeLabel = (deviceTypeCode) => {
    //   let label = '';
    //   deviceColumns.value.forEach((item: any) => {
    //     if (deviceTypeCode === item.dictValue) {
    //       label = item.dictLabel;
    //     }
    //   });
    //   return label;
    // };
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getDeviceTypeList();
          case 2:
            _context2.next = 4;
            return getTaskDetail({
              inspectionTaskId: Number(id),
              inspectionTaskRuleId: Number(ruleId)
            });
          case 4:
            data = _context2.sent;
            detail.value = data || {};
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(detail).taskName || '--'), 1)])])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detail).inspectionDeviceList, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "detail-item-content device-info",
          key: index
        }, [_createElementVNode("div", _hoisted_11, _toDisplayString(item.deviceModel || '--'), 1), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString(item.deviceTypeCode || '--'), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString(item.deviceName || '--'), 1)]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, _toDisplayString(item.deviceAddr || '--'), 1)]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, _toDisplayString(item.deviceNum || '--'), 1)])]);
      }), 128))]), _createElementVNode("div", _hoisted_24, [_hoisted_25, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(detail).inspectionTaskRuleList, function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          class: "detail-item-content",
          key: index
        }, [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", _hoisted_28, _toDisplayString(item.inspectionTaskDesc || '--'), 1)]), _createElementVNode("div", _hoisted_29, [_hoisted_30, _createElementVNode("div", _hoisted_31, _toDisplayString(item.startTime || '--'), 1)]), _createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("div", _hoisted_34, _toDisplayString(item.endTime), 1)]), _createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("div", _hoisted_37, _toDisplayString(item.inspectionTime || '--'), 1)]), _createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("div", _hoisted_40, _toDisplayString(item.assessorUserName || '--'), 1)]), _createElementVNode("div", _hoisted_41, [_hoisted_42, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.inspectionItemInfoList, function (itemInfo, itemInfoIndex) {
          return _openBlock(), _createElementBlock("div", {
            class: "content-item-value_3",
            key: itemInfoIndex
          }, [_createElementVNode("div", _hoisted_43, _toDisplayString(itemInfo.inspectionItemInfo || '--'), 1), _createElementVNode("div", _hoisted_44, [_hoisted_45, _createElementVNode("div", _hoisted_46, _toDisplayString(itemInfo.inspectionUserName), 1)])]);
        }), 128))])]);
      }), 128))])])]);
    };
  }
});